import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup } from 'react-bootstrap';
import { FormContext } from '../../FormContext';

const FormInputToolbar = ({ toolbar, ...rest }) => {
  const { manager } = useContext(FormContext);
  const toolbarHelpers = manager.toolbarHelpers || {};
  const DefaultHelper = toolbarHelpers.default;

  return (
    <div className="input-toolbar-wrapper">
      <div className="input-toolbar">
        <ButtonGroup>
          {toolbar.map((helper, i) => {
            const Helper = toolbarHelpers[helper];

            if (Helper) {
              return <Helper key={i} helper={helper} {...rest} />;
            }

            if (DefaultHelper) {
              return <DefaultHelper key={i} helper={helper} {...rest} />;
            }

            console.warn(`Toolbar item ${helper} was not used`);

            return null;
          })}
        </ButtonGroup>
      </div>
    </div>
  );
};

FormInputToolbar.defaultProps = {
  toolbar: [],
};

FormInputToolbar.propTypes = {
  toolbar: PropTypes.array,
};

export default FormInputToolbar;
